export default __webpack_public_path__ + "static/media/success.icon.9e8eb758.svg";